import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ProgressUpdate {
  percentage: number;
  [key: string]: any;
}

interface GameUploadState {
  percentage: number;
  message: string;
  updates: ProgressUpdate[];
}

const initialState: GameUploadState = {
  percentage: -1,
  message: '',
  updates: [],
};

const gameUploadSlice = createSlice({
  name: 'gameUploadResults',
  initialState,
  reducers: {
    processingGameUpload: (state, action: PayloadAction<ProgressUpdate>) => {
      return {
        ...state,
        percentage: action.payload.percentage,
        updates: [...state.updates, action.payload],
      };
    },
    clearGameUpload: () => {
      return initialState;
    },
  },
});

export const { processingGameUpload, clearGameUpload } =
  gameUploadSlice.actions;

export default gameUploadSlice.reducer;
